'use client'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from '../../context/ConfigContext'

import { ModalContext, type ModalContextType } from '../../context/ModalContext'
import ModalCart from '../Modal/ModalCart'
import Icon from '../Icon/Icon'
import { Icons } from '../Icon/constants'
import { CartContext } from '../../context/CartContext'

export function MiniCartCta(props: { classes?: { root?: string; icon?: string } }) {
  const [itemQuantity, setItemQuantity] = useState<number>(0)
  const { cart, modalUuid } = useContext(CartContext)
  const { addModal, removeModal } = useContext(ModalContext) as ModalContextType
  const t = useTranslation()

  useEffect(() => {
    setItemQuantity(cart.items?.reduce((total, cartItem) => total + cartItem.quantity, 0) || 0)
  }, [cart.items])

  return (
    <button
      className={props.classes?.root}
      aria-label={t('Cart', {}, false)}
      onClick={() => {
        addModal({
          uuid: modalUuid,
          component: <ModalCart uuid={modalUuid} onClose={() => removeModal(modalUuid)} />,
        })
      }}>
      <Icon
        className={props.classes?.icon || 'size-6'}
        title={t('Shopping Cart')}
        iconName={Icons.SHOPPING_BAG}
      />
      <span className='relative'>
        {itemQuantity > 0 && (
          <span className='absolute bg-black bottom-0 -left-3 text-2xs text-white rounded-full leading-4 size-4 p-0'>
            {itemQuantity}
          </span>
        )}
      </span>
    </button>
  )
}
